"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgEyeOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.eye-off_outline_svg__cls-1{display:none}')),
        React.createElement("path", { className: "eye-off_outline_svg__cls-1", d: "M0 0h32v32H0z", id: "eye-off_outline_svg__transparent_box" }),
        React.createElement("g", { id: "eye-off_outline_svg__OUTLINE" },
            React.createElement("path", { className: "eye-off_outline_svg__cls-1", d: "M20 16a3.88 3.88 0 00-.15-1L15 19.85a3.87 3.87 0 001 .15 4 4 0 004-4z" }),
            React.createElement("path", { d: "M5.56 22.43L7 21a18.29 18.29 0 01-3.16-3.93L3.16 16l.65-1.09C6.69 10.1 11.47 7 16 7a11.39 11.39 0 014.17.83l1.52-1.51A13.67 13.67 0 0016 5C10.78 5 5.33 8.48 2.1 13.88L.83 16l1.27 2.12a19.84 19.84 0 003.46 4.31z" }),
            React.createElement("path", { d: "M10 16a6.26 6.26 0 00.26 1.74L12 16a4 4 0 014-4l1.74-1.74A5.86 5.86 0 0016 10a6 6 0 00-6 6zM29.9 13.88A20.24 20.24 0 0025.81 9L30 4.82V2L2 30h2.82l4.72-4.72A13.88 13.88 0 0016 27c5.21 0 10.67-3.49 13.9-8.88L31.17 16zM19.85 15a3.88 3.88 0 01.15 1 4 4 0 01-4 4 3.88 3.88 0 01-1-.15zm8.33 2.12C25.31 21.9 20.53 25 16 25a11.68 11.68 0 01-5-1.2l2.4-2.39A6 6 0 0022 16a6.07 6.07 0 00-.59-2.59l3-3a18 18 0 013.78 4.49l.64 1.1z" }))));
}
exports.default = SvgEyeOffOutline;
//# sourceMappingURL=EyeOffOutline.js.map